import axios from 'axios';
import type { ProfileInformation } from '../types/profile-information';
import { SignupErrorKey } from '../../common/enums/signup-error-key';

export class VerifyUserService {
  static async verify({
    profileInformation,
    id,
    key,
  }: {
    profileInformation: ProfileInformation;
    id: string;
    key: string;
  }): Promise<string> {
    const body = new FormData();
    body.append('user-first-name', profileInformation.firstName);
    body.append('user-last-name', profileInformation.lastName);
    body.append('user-new-password', profileInformation.password);
    body.append('user-repeat-password', profileInformation.password);
    body.append('user-language', profileInformation.language);
    body.append('user-mobile', profileInformation.phoneNumber);
    body.append('signup-version', '2');
    const { request, data } = await axios.post(`/signup/v2/verify-user/${id}/${key}`, body);
    if (data.error) {
      throw new Error(data.error);
    }
    if (!request.responseURL) {
      throw new Error(SignupErrorKey.NoResponseUrl);
    }
    return request.responseURL;
  }
}

export class VerifyUserServiceV3 {
  static async verify({
    profileInformation,
    id,
    key,
    isInvitation,
  }: {
    profileInformation: ProfileInformation;
    id: string;
    key: string;
    isInvitation: boolean;
  }): Promise<string> {
    const { request, data } = await axios.put(
      `/signup/${id}/${key}?isInvitation=${isInvitation}&version=3`,
      profileInformation
    );
    if (data.error) {
      throw new Error(data.error);
    }
    if (!request.responseURL) {
      throw new Error(SignupErrorKey.NoResponseUrl);
    }
    return request.responseURL;
  }
}
